import React from 'react';
import '../../styles/info.css';
import { useLanguage } from "../common/LanguageContext";

function Info() {
  const { translations } = useLanguage();
  return (
    <main className="info-page">
      <h1 className="info-title">{translations.infoPage.title}</h1>
      <section className="info-content">
        <div className="info-left">
          <h2 className="info-section-title">{translations.infoPage.p1.title1}</h2>
          <p className="info-text">
            {translations.infoPage.p1.text1}
          </p>
          <p className="info-text">
            {translations.infoPage.p1.text2}
          </p>
          <h2 className="info-section-title second-title">{translations.infoPage.p1.title2}</h2>
          <p className="info-text">
            {translations.infoPage.p1.text3}
          </p>
        </div>
        <div className="info-right">
          <ul className="info-details">
            <li>{translations.infoPage.phone}8 928 1300 7 88</li>
            <li>{translations.infoPage.address}</li>
            <li>
              <a href="https://t.me/Nirivs" target="_blank" rel="noopener noreferrer" className='telegram-link'>
                <img src="/TLG_logo_small.svg" alt="Telegram" className="telegram-icon" />
                <div>Nirivs</div>
              </a>
            </li>
            <li>ООО «НАИРИВС»</li>
            <li>ИНН: 6165237309</li>
            <li>КПП: 616501001</li>
            <li>ОГРН: 30461681400181</li>
          </ul>
          <img src="/map.png" alt="Карта местоположения" className="info-map" />
        </div>
      </section>
    </main>
  );
}

export default Info;
